import Button from '@rezdy/components/Button';
import Grid from '@rezdy/components/Grid';
import { H2 } from '@rezdy/components/Heading';
import TextStyle from '@rezdy/components/TextStyle';
import React, { useEffect } from 'react';
import { SIGN_IN } from '../../constants/routes';
import pendo from '../../services/pendo';
import { push } from '../../services/routing';
import { ContactSupport } from '../ContactSupport';
import { MarketingLayout } from '../Layout/MarketingLayout';

export const TempPasswordSent = ({ username }: { username: string }) => {
    useEffect(() => {
        pendo.trackEvent(
            pendo.buildAnonymousVisitor({ email: username }),
            'Hubspot Sign Up - Temporary Password Notice Viewed'
        );
    }, []);

    return (
        <MarketingLayout>
            <Grid.Container rowGap="24px">
                <H2>Your temporary password</H2>
                <TextStyle as="p">Almost there! Your temporary password has been sent to {username}.</TextStyle>
                <TextStyle as="p">
                    Once received, head to our login page to access your account for the first time. You will be
                    prompted to reset this password upon successful login.
                </TextStyle>
                <Button type="submit" action="primary" width="100%" onClick={() => push(SIGN_IN)}>
                    Password received? Click here to login
                </Button>
                <ContactSupport />
            </Grid.Container>
        </MarketingLayout>
    );
};
